"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import { BLUR_PLACEHOLDER } from '@/lib/componentutills';
type AstrologyTabItem = {
  label: string;
  active?: boolean;
};
type AstrologyHeaderData = {
  imageSrc: string;
  imageAlt: string;
  title: string;
  dateRange: string;
  tabs: AstrologyTabItem[];
};
const ASTROLOGY_HEADER_DATA: AstrologyHeaderData = {
  imageSrc: "https://media.dinamani.com/dinamani/2026-02-27/a2m82fgm/மேஷம்.png",
  imageAlt: "Mesham Logo",
  title: "மேஷ ராசகம்",
  dateRange: "March 21 - April 19",
  tabs: [{
    label: "Today",
    active: true
  }, {
    label: "This Week"
  }, {
    label: "This Month"
  }, {
    label: "This Year"
  }]
};
export default function AstrologyTab() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-14 h-14"><Image src={ASTROLOGY_HEADER_DATA.imageSrc} alt={ASTROLOGY_HEADER_DATA.imageAlt} width={68} height={68} className="w-68 h-14 object-contain rounded-full" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-4">{t0}<div className="flex flex-col"><h2 className="text-24-tamil-700 text-FFFFFF">{ASTROLOGY_HEADER_DATA.title}</h2><p className="text-14-tamil-500 text-DCDCDC">{ASTROLOGY_HEADER_DATA.dateRange}</p></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="w-full bg-012061 text-FFFFFF px-6 py-4 lg:flex grid grid-cols-1 items-center justify-between gap-4">{t1}<div className="flex gap-8 text-sm">{ASTROLOGY_HEADER_DATA.tabs.map(_temp)}</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(tab) {
  return tab.active ? <div key={tab.label} className="flex flex-col"><span className="text-14-tamil-700">{tab.label}</span><span className="w-8 h-1 bg-FFDB59 mt-1" /></div> : <span key={tab.label} className="text-FFFFFF text-14-tamil-400 opacity-90 hover:opacity-100 cursor-pointer">{tab.label}</span>;
}